"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObservable = void 0;
var react_1 = require("react");
/**
 * Equivalent of https://docs.evt.land/api/react-hooks
 */
function useObservable(effect, deps) {
    (0, react_1.useEffect)(function () {
        var subscriptions = [];
        effect({
            "registerSubscription": function (subscription) { return subscriptions.push(subscription); }
        });
        return function () {
            subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
            subscriptions.length = 0;
        };
    }, deps);
}
exports.useObservable = useObservable;
//# sourceMappingURL=useObservable.js.map